export default __webpack_public_path__ + "static/media/dash_4.aff92d81.png";